import { PropsWithChildren, useMemo, useState } from 'react';
import { Content } from '@/lib';
import ContentGalleryDialog from './ContentGalleryDialog';

import ContentGalleryContext from './ContentGalleryContext';

interface ContentGalleryProviderProps {
  content: Content.Data[];
}

export default function ContentGalleryProvider({ children, content }: PropsWithChildren<ContentGalleryProviderProps>) {
  const [selectedImage, setSelectedImage] = useState<Content.Image | null>(null);
  const images = useMemo(
    () => (content || []).filter(({ type }) => type === Content.Type.image).map(({ data }) => data as Content.Image),
    [content]
  );

  const value = useMemo(() => ({ images, selectedImage, setSelectedImage }), [images, selectedImage, setSelectedImage]);

  return (
    <ContentGalleryContext.Provider value={value}>
      {children}
      {!!selectedImage && <ContentGalleryDialog />}
    </ContentGalleryContext.Provider>
  );
}
